// // Use NEXT_PUBLIC_ENV or NODE_ENV to determine environment
// const isStaging =
//   process.env.NEXT_PUBLIC_ENV === "staging" ||
//   process.env.NEXT_PUBLIC_STAGING === "true";

export const SERVICE_URL = process.env.NEXT_PUBLIC_SERVICE_URL ||
  "https://portal-api.spicenet.io/api/v1";
